/* One screen of scroll per step: the stage pins for the whole run while the steps pass over it. */
.story {
  position: relative;
  background: #0b0e12;
}
.stage {
  position: sticky;
  top: 0;
  height: 100vh;
  height: 100svh;
  overflow: hidden;
}
/* Keeps the step text readable over the scan; the road itself sits right of centre. */
.scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(8, 13, 19, 0.94) 0%,
    rgba(8, 13, 19, 0.65) 30%,
    transparent 58%
  );
}
.steps {
  position: relative;
  z-index: 3;
  /* Pulls the steps up over the pinned stage instead of after it. */
  margin-top: -100vh;
  margin-top: -100svh;
  /* The scene isn't interactive; only the text column takes pointer events. */
  pointer-events: none;
}
.step {
  display: flex;
  align-items: center;
  min-height: 100vh;
  min-height: 100svh;
}
.card {
  width: min(100% - 2 * var(--sp-5), 34rem);
  /* On the page's container edge, like every other section's text. */
  margin-left: calc((100% - min(100% - 2 * var(--sp-5), var(--container))) / 2);
  pointer-events: auto;
  opacity: 0.3;
  transition: opacity 400ms var(--ease);
}
.step[data-active] .card {
  opacity: 1;
}
.kicker {
  margin-bottom: var(--sp-3);
  font-weight: 600;
  color: var(--accent-text);
}
.title {
  max-width: 14ch;
  margin-bottom: var(--sp-12);
  font-size: clamp(2.25rem, 1.3rem + 2.6vw, 4rem);
  line-height: var(--lh-display);
  letter-spacing: var(--tracking-display);
  color: var(--text-on-dark);
}
.stepNo {
  margin-bottom: var(--sp-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-on-dark-muted);
}
/* --story-title-size and --story-text-size let a page tighten a long story's type. */
.stepTitle {
  font-size: var(--story-title-size, clamp(1.625rem, 1rem + 1.3vw, 2.5rem));
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-heading);
  color: var(--text-on-dark);
}
.stepText {
  max-width: 30rem;
  margin: var(--sp-4) 0 0;
  font-size: var(--story-text-size, var(--fs-md));
  color: var(--text-on-dark-muted);
}
.actions {
  margin: var(--sp-8) 0 0;
}
.note {
  max-width: 26rem;
  margin: var(--sp-6) 0 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

/* The heading's place on phones: above the story rather than in its first card. */
.lead {
  display: none;
}

/* ---- phones: the steps sit at the bottom of the screen, on a glass card ---- */
@media (max-width: 47.99rem) {
  .lead {
    display: block;
    padding: var(--sp-12) var(--sp-4) var(--sp-6);
    background: #0b0e12;
  }
  .card .kicker,
  .card .title {
    display: none;
  }
  .scrim {
    background: linear-gradient(0deg, rgba(8, 13, 19, 0.9) 0%, transparent 55%);
  }
  .step {
    align-items: flex-end;
    padding-bottom: 6svh;
  }
  .card {
    width: auto;
    margin-inline: var(--sp-4);
    padding: var(--sp-5);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: var(--radius-lg);
    background: rgba(8, 13, 19, 0.8);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
  }
  .title {
    margin-bottom: var(--sp-5);
    font-size: 2rem;
  }
}

/* ---- reduced motion: a still of the ending, with the steps as a plain list below ---- */
.story[data-static] .stage {
  position: relative;
  height: 70vh;
}
.story[data-static] .steps {
  margin-top: 0;
  padding-block: var(--sp-10);
}
.story[data-static] .step {
  min-height: 0;
  padding-block: var(--sp-6);
}
.story[data-static] .card {
  opacity: 1;
}

/* ---- a step's colour legend (the classified cloud) ------------------------- */
.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-5);
  margin: var(--sp-5) 0 0;
  font-size: var(--fs-sm);
  color: var(--text-on-dark-muted);
}
.legend li {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
}
.legend li::before {
  content: "";
  width: 0.7em;
  height: 0.7em;
  border-radius: 50%;
  background: var(--swatch);
}

/* ---- a step's chip and its "What you get" line ------------------------------ */
.stepNo {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}
.stepResult {
  max-width: 30rem;
  margin: var(--sp-4) 0 0;
  padding-left: var(--sp-4);
  border-left: 2px solid color-mix(in srgb, var(--accent) 70%, transparent);
  font-size: var(--story-text-size, var(--fs-md));
  color: var(--text-on-dark);
}
.stepResult span {
  display: block;
  margin-bottom: 2px;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-on-dark-muted);
}
